import { initializeCommand } from '../index';
import { importServices } from '../services';

export const command = 'import';
export const describe = `Import the services from external repositories.`;

export const builder = () => {
  initializeCommand();
};

export const handler = async(): Promise<void> => {
  await importServices();
};